import { useState, useRef, useEffect } from "react";
// import { updateCaptcha } from "lib/captcha";

interface Status {
  submitted: boolean;
  submitting: boolean;
  info: { error: boolean; msg: string | null };
}

const useForm = () => {
  const emailRef = useRef(null);
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);

  const [captchaPassed, setCaptchaPassed] = useState(true);
  // useEffect(() => {
  //   updateCaptcha(setCaptchaPassed, "subscribe");
  // }, []);

  const [status, setStatus] = useState<Status>({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null },
  });

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // if (!captchaPassed) {
    //   setStatus({
    //     submitted: true,
    //     submitting: false,
    //     info: { error: true, msg: "Unable to validate" },
    //   });
    //   return;
    // }

    const data = {
      email: emailRef.current.value,
      firstName: firstNameRef.current.value,
      lastName: lastNameRef.current.value,
    };

    setStatus({
      submitted: true,
      submitting: true,
      info: { error: false, msg: null },
    });
    const res = await fetch("/api/add-contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const text = await res.text();

    setStatus({
      submitted: true,
      submitting: false,
      info: { error: res.status !== 200, msg: text },
    });
  };

  const onValuesChange = () => {
    if (status.submitted) {
      setStatus({
        submitted: false,
        submitting: false,
        info: { error: false, msg: null },
      });
    }
  };

  return {
    emailRef,
    firstNameRef,
    lastNameRef,
    onValuesChange,
    onSubmit,
    status,
    captchaPassed,
  };
};

export default useForm;
